<template>
    <div class="com-vip-button-box">
        <button class="com-vip-button" @click="clickVipButton">
            <p class="title">一键免费解锁</p>
            <p class="sub-title" v-if="userData && userData.vip < 20 && vipDayLuckInfo && vipDayLuckInfo.num > 0">（每日限量特惠放送，今日还剩<span class="red2">{{ vipDayLuckInfo.num }}</span>位）</p>
        </button>
    </div>
</template>

<script>
import { ACTIVITY_DOM } from '../../modules/dom';
import { MIX, UA, UTILS } from '../../modules/utils';
import { SCHEME } from '../../modules/utils'
export default {
    name: 'VipButton',
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        vipDayLuckInfo() {
            return this.$store.state.user.vipDayLuckInfo;
        },
    },
    props: {
        frompage: {
            type: String,
            default() { return '' }
        }
    },
    methods: {
        clickVipButton() {
            var me = this,
                detailInfo = this.$store.state.detail.personInfo;
            if(!detailInfo || !detailInfo.id) { return; }

            let curPath = this.$router.history.current.path;
            let uid = this.$store.state.embedded.userUid;
            let vip = this.$store.state.embedded.userVip;
            let queryData = this.$store.state.embedded.queryData;

            console.log('clickVipButton----', uid, vip, (vip != undefined && vip != 20 && vip != 30), queryData, detailInfo.id)
            console.log('clickVipButton----', this.frompage);
            if(this.frompage == 'report') {
                MIX.trackButtonClicked('ai_vip_one_click_unlock');
            }else if(this.frompage == 'nature') {
                MIX.trackButtonClicked('talent_vip_one_click_unlock');
            }

            if(this.userData && parseInt(this.userData.vip) <= 10) {
                this.$store.state.user.showActDayLuckPop = true;
                setTimeout(() => {
                    ACTIVITY_DOM.updateActivityDayLuckDom();
                }, 100);
                return;
            }
            this.$store.dispatch('report/freeUnlockReport', {
                detailInfo: detailInfo,
                frompage: me.frompage,
                failCb: function() {
                    this.$toast('免费解锁失败，请稍后再试');
                }
            });
        }
    }
}
</script>